module.exports = __webpack_public_path__ + "static/media/starshipit1_preview.f65831ee.jpg";